import axios from './HTTP'

export default {
  create (params, callback, errorCallback) {
    axios
      .post(`/api/shifts/${ params.shift_id }/client_reviews.json`, {
        shift_review_params: params
      })
      .then(response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  getForShift (id, callback, errorCallback) {
    axios
      .get(`/api/shifts/${ id }/client_reviews.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

}
